"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgInCloseThin = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgInCloseThin = function SvgInCloseThin(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "11",
    height: "12",
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.180899 1.08991C-0.0660038 0.834781 -0.0593319 0.427802 0.1958 0.180899C0.450933 -0.0660034 0.857912 -0.0593316 1.10481 0.195801L5.3574 4.59014L9.60998 0.195801C9.85688 -0.0593316 10.2639 -0.0660034 10.519 0.180899C10.7741 0.427802 10.7808 0.834781 10.5339 1.08991L6.25199 5.51455L10.5334 9.93866C10.7803 10.1938 10.7736 10.6008 10.5185 10.8477C10.2634 11.0946 9.85637 11.0879 9.60947 10.8328L5.3574 6.43896L1.10532 10.8328C0.858419 11.0879 0.451439 11.0946 0.196307 10.8477C-0.0588256 10.6008 -0.0654973 10.1938 0.181405 9.93866L4.4628 5.51455L0.180899 1.08991Z",
    fill: "currentColor"
  }));
};

exports.SvgInCloseThin = SvgInCloseThin;